import {ApiClient} from '@hconnect/apiclient'
import {AssetSnapshot, AssetsHistory, Status} from '@hconnect/common/types'
import {Moment} from 'moment-timezone'

import {getAssetsHistoryPath} from '../api'
import {validateBaseLoadInAssets} from '../selectors'

export type MomentRange = [start: Moment, end: Moment]

export const ASSETS_HISTORY_QUERY_KEY = 'assetsHistory'

export const assetsHistoryQueryOptions = (plantId: string, [from, to]: MomentRange) => ({
  queryKey: [ASSETS_HISTORY_QUERY_KEY, plantId, from.toISOString(), to.toISOString()] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const path = getAssetsHistoryPath(plantId)
    const {data: assetsHistory} = await ApiClient.axiosInstance.get<AssetsHistory>(path, {
      params: {from: from.toISOString(), to: to.toISOString()},
      signal
    })
    const latestAssets = Object.values(assetsHistory)
      .map((assets) => assets[assets.length - 1])
      .filter((asset): asset is AssetSnapshot => !!asset && asset.status !== Status.Deleted)
    validateBaseLoadInAssets(latestAssets)
    return assetsHistory
  }
})
